export default __webpack_public_path__ + "static/media/ion_airplane.9bc418fe.svg";